import { createSlice } from '@reduxjs/toolkit';

import { InitialAuthStateType } from '../types/authTypes';
const name = 'auth';

const INITIAL_SCREEN: InitialAuthStateType = {
  token: null,
  user: null,
  isLoggedIn: false,

  isLoginLoading: false,
  isLogoutLoading: false,
};

const authSlice = createSlice({
  name,
  initialState: INITIAL_SCREEN,
  reducers: {
    setUserData: (state, action) => {
      state.user = action.payload;
    },
    login: (state, action) => {
      // Perform the login logic here (if required)
      state.isLoginLoading = true;
    },
    loginSuccess: (state, action) => {
      state.token = action.payload;
      state.isLoggedIn = true;
      state.isLoginLoading = false;
    },
    loginFailure: state => {
      state.token = null;
      state.isLoggedIn = false;
      state.isLoginLoading = false;
    },
    logout: state => {
      state.isLogoutLoading = true;
    },
    logoutSuccess: state => {
      state.token = null;
      state.user = null;
      state.isLoggedIn = false;
      state.isLogoutLoading = false;
    },
    logoutFailure: state => {
      state.isLogoutLoading = false;
    },
    refreshTokenSuccess: (state, action) => {
      state.token = action.payload;
    },
    refreshTokenFailure: state => {
      state.token = null;
      state.isLoggedIn = false;
    },
  },
});

export const {
  setUserData,
  login,
  loginSuccess,
  loginFailure,
  logout,
  logoutSuccess,
  logoutFailure,
  refreshTokenSuccess,
  refreshTokenFailure,
} = authSlice.actions;

export default authSlice.reducer;
